import { Routes, Route } from 'react-router-dom';
import { Dashboard } from '../modules/aggregator/pages/Dashboard';
import { Withoutabha } from '../modules/aggregator/pages/Withoutabha';
import { Detailsabha } from '../modules/aggregator/pages/Detailsabha';
import { Machinemaster } from '../modules/pmndp/pages/Machine-master';
import { SlotManagement } from '../modules/pmndp/pages/Slot-management-list';
import { PatientsDialysisModules } from '../modules/pmndp/pages/Patients-dialysis-module';
import { Underdevloped } from '../modules/aggregator/pages/Underdevloped';
import NCDRoutes from './ncd.routes';
import SickleRoutes from './sickle.routes';
import PMNDPRoutes from './pmndp.routes';
import UWINRoutes from './uwin.routes';
import NikshayRoutes from './nikshay.routes';
import AggregatorRoutes from './aggregator.routes';
import EOPDRoutes from './eopd.routes';
import Uwinsession from '../modules/uwin/pages/Uwinsession';
import SessionDetails from '../modules/uwin/components/SessionDetails';
import PreResgistrationUwin from '../modules/uwin/components/Pre-registration-uwin';
// import RCHRoutes from './rch.routes';
import RchBeneficiaries from '../modules/RCH/RchBeneficiaries';
import DailyReport from '../modules/AAM/Component/DailyReport';

const AppRoutes = () => {
  return (
    <Routes>
      <Route index element={<Dashboard />} />
      <Route path="/dashboard" element={<Dashboard />} />
      <Route path="/Session" element={<Uwinsession />} />
      <Route path="/Sessions" element={<SessionDetails />} />
      <Route path="/withoutabha" element={<Withoutabha />} />
      <Route path="/detailsabha" element={<Detailsabha />} />
      <Route path="/machine-master" element={<Machinemaster />} />
      <Route path="/slot-management" element={<SlotManagement />} />
      <Route path="/patient-dialysis-list" element={<PatientsDialysisModules />} />
      <Route path="/Underdevloped" element={<Underdevloped />} />
      <Route path="/ncd/*" element={<NCDRoutes />} />
      <Route path="/sickle/*" element={<SickleRoutes />} />
      <Route path="/pmndp/*" element={<PMNDPRoutes />} />
      <Route path="/uwin/*" element={<UWINRoutes />} />
      <Route path="/nikshay/*" element={<NikshayRoutes />} />
      <Route path="/aggregator/*" element={<AggregatorRoutes />} />
      <Route path="/e-opd/*" element={<EOPDRoutes />} />
      <Route path="/uwin-registration" element={<PreResgistrationUwin />} />
      {/* <Route path="/rch/*" element={<RCHRoutes />} /> */}
      <Route path="/janani-beneficiaries" element={<RchBeneficiaries />} />
      <Route path="/Daily-report" element={<DailyReport />} />
    </Routes>
  );
};

export default AppRoutes;